import { compile, PathFunction } from 'path-to-regexp';

import type { Parameters } from '@navigation/routes.types';

/*
 * Кэш скомпилированных шаблонов с потолком.
 *
 * Потолок был снят в первой редакции AF-351 как мёртвый: все двенадцать вызовов
 * `makeDynamicApiRoute` подставляют константу из `ApiUrls`, то есть множество
 * ключей замкнуто и до десяти тысяч не доходит. Рассуждение верное про ВЫЗОВЫ и
 * неверное про решение: тот же файл лежит в трёх приложениях, и у `applications`
 * ту же ветвь закрыли **тестом** (AF-354), замерив её цену — `compile()` десять
 * тысяч раз стоит 6–8 мс, на порядок меньше поднятия `happy-dom` для того же
 * файла. Держать в analyst другую редакцию одного файла — ровно то расхождение,
 * с которым борется весь эпик, поэтому потолок возвращён, а ветвь закрыта
 * проверкой рядом (`routes.utilities.test.ts`).
 */
const cache: Record<
  string,
  PathFunction<Partial<Record<string, string | string[]>>>
> = {};
const cacheLimit = 10_000;
let cacheCount = 0;

const compilePath = (path: string) => {
  const cached = cache[path];
  if (cached) return cached;

  const generator = compile(path);

  if (cacheCount < cacheLimit) {
    cache[path] = generator;
    cacheCount += 1;
  }

  return generator;
};

export const makeDynamicApiRoute = (
  path: string,
  parameters: Parameters,
): string => {
  const generator = compilePath(path);
  return path === '/' ? path : generator(parameters);
};
